import React, { Suspense } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Login from '../Auth/Login'
import NotFound from '../layouts/error/NotFound'
import PrivateRoute from './PrivateRoute'
import Index from '../pages/Index'
import Register from '../pages/Register'
import DanAuthPage from '../pages/dan/DanAuthPage'
import VerifyAccount from '../pages/VerifyAccount'
import MerchantSetup from '../pages/MerchantSetup'
import MerchantDashboard from '../pages/MerchantDashboard'
import CreateInvoice from '../pages/CreateInvoice'
import PublicPayment from '../pages/PublicPayment'
import Profile from '../pages/Profile'
import ResetPassword from '../Auth/ResetPassword'
import ForgotPassword from '../Auth/ForgotPassword'
import InvoiceReport from '../pages/report/InvoiceReport'
import InvoiceTransactionReport from '../pages/report/InvoiceTransactionReport'
import PayLinkApiDocs from '../pages/developers/PayLinkApiDocs'
import PartnerDashboard from '../pages/partner/PartnerDashboard'
import PartnerMerchants from '../pages/partner/PartnerMerchants'
import PartnerDocs from '../pages/partner/PartnerDocs'

const RouteConfig = React.lazy(() => import('../pages/RouteConfig'));

const loadingComp = <div className="k-loading-mask" style={{ zIndex: 100000, position: 'fixed' }}>
    <span className="k-loading-text">Loading</span>
    <div className="k-loading-image"></div>
    <div className="k-loading-color"></div>
</div>

const MenuRoutes = () => {
    return (
        <Routes>
            <Route path="/*" element={<RouteConfig />} />
        </Routes>
    );
};

export default function CoreRoutes() {
    return (
        <BrowserRouter>
            <Suspense fallback={loadingComp}>
                <Routes>
                    <Route path="/" element={<Index />} />
                    <Route element={<PrivateRoute />}>
                        <Route path="/menu/*" element={<MenuRoutes />} />
                        <Route path="/merchant/setup" element={<MerchantSetup />} />
                        <Route path="/merchant/dashboard" element={<MerchantDashboard />} />
                        <Route path="/profile" element={<Profile />} />
                        <Route path="/invoice/create" element={<CreateInvoice />} />
                        <Route path="/invoice/:invoiceId/:ordernum" element={<PublicPayment />} />
                        <Route path="/link/:merchantName" element={<PublicPayment />} />
                        <Route path="/dan-auth" element={<DanAuthPage />} />
                        <Route path="/verify-account" element={<VerifyAccount />} />
                        <Route path="/report/invoice" element={<InvoiceReport />} />
                        <Route path="/report/invoice-transaction" element={<InvoiceTransactionReport />} />
                        <Route path="/partner/dashboard" element={<PartnerDashboard />} />
                        <Route path="/partner/merchants" element={<PartnerMerchants />} />
                        <Route path="/partner/docs" element={<PartnerDocs />} />
                    </Route>
                    <Route path="/pay/:invoiceId/:ordernum?" element={<PublicPayment />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password/:token" element={<ResetPassword />} />
                    <Route path="/developers/paylink-api" element={<PayLinkApiDocs />} />
                    <Route path='*' element={<NotFound />} />
                </Routes>
            </Suspense>
        </BrowserRouter>
    )
}
